// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"searchbox_searchBox__A6N_f","searchBoxBackground":"searchbox_searchBoxBackground__PvvZI"};